function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { appApis, loginObj } from '@/services/base';
var PROFILING = 'profiling';
var API_PROFILE = Object.assign({}, appApis);
/**
 * getRecords takes any argument.
 * @param {String} table_name table name
 * @param {Number} record_id  record identifier
 * @param records
 * @return {Object} Record depends on the table_name and record_id
 */
API_PROFILE.getRecords = function () {
  var table_name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var record_id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var records = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'all';
  var login = loginObj();
  var params = _objectSpread({
    record_id: record_id,
    records: records
  }, login);
  return appApis.get("/".concat(PROFILING, "/").concat(table_name), {
    params: params
  }).then(function (response) {
    return response['data'];
  }).catch(function (error) {
    console.error(error);
  });
};

/**
 * postRecord takes any argument.
 * @param {String} table_name table name to create a new record
 * @param {Object} values values to save dependes on table_name
 * @return {Object} Status of th process
 */
API_PROFILE.postRecord = function () {
  var table_name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var login = loginObj();
  var params = {
    login: login,
    values: values
  };
  return appApis.post("/".concat(PROFILING, "/").concat(table_name), params).then(function (response) {
    return response['data'];
  }).catch(function (error) {
    console.error(error);
  });
};

/**
 * putRecord takes any argument.
 * @param {String} table_name table name to write
 * @param {Object} values values to write
 * @param {Object} oldValues old values to save in log table
 * @return {Object} Status of th process
 */
API_PROFILE.putRecord = function () {
  var table_name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var oldValues = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var login = loginObj();
  var params = {
    login: login,
    values: values,
    oldValues: oldValues
  };
  return appApis.put("/".concat(PROFILING, "/").concat(table_name), params).then(function (response) {
    return response['data'];
  }).catch(function (error) {
    console.error(error);
  });
};

/**
 * deleteRecord takes any argument.
 * @param {String} table_name table name to delete
 * @param {Number} record_id record identifier to delete
 * @return {Object} Status of th process
 */
API_PROFILE.deleteRecord = function () {
  var table_name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var document_id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var login = loginObj();
  var params = _objectSpread({
    document_id: document_id
  }, login);
  return appApis.delete("/".concat(PROFILING, "/").concat(table_name), {
    params: params
  }).then(function (response) {
    return response['data'];
  }).catch(function (error) {
    console.error(error);
  });
};
API_PROFILE.getReferenceRule = function () {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var login = loginObj();
  var params = _objectSpread(_objectSpread({}, login), data);
  return appApis.get("/".concat(PROFILING, "/referenceRule"), {
    params: params
  }).then(function (response) {
    return response['data'];
  }).catch(function (error) {
    console.error(error);
  });
};

/**
 * putTableResult takes any argument.
 * @param {String} table_name table name to write
 * @param {Object} values values to write
 * @param {Object} oldValues old values to save in log table
 * @return {Object} Status of th process
 */
API_PROFILE.putTableResult = function () {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var login = loginObj();
  var params = _objectSpread({
    login: login
  }, data);
  return appApis.put("/".concat(PROFILING, "/table_result"), params).then(function (response) {
    return response['data'];
  }).catch(function (error) {
    console.error(error);
  });
};
export default API_PROFILE;